module.exports = __webpack_public_path__ + "c_static/img/买家秀评价教程.2f8ade5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/买家秀评价教程.png
// module id = jc+7
// module chunks = 33